/* Event helper for "Chat about this" on feed items.
   Dispatches a CustomEvent that KiwiChatWidget listens to. */

export const CHAT_ABOUT_ITEM_EVENT = "kiwi-chat-about-item";

export const ANALYZABLE_CONTENT_TYPES = ["video", "article", "email", "podcast"];

export interface ChatAboutItemDetail {
	itemId: string;
	title: string;
	contentType: string;
}

export function dispatchChatAboutItem(itemId: string, title: string, contentType: string) {
	window.dispatchEvent(
		new CustomEvent<ChatAboutItemDetail>(CHAT_ABOUT_ITEM_EVENT, {
			detail: { itemId, title, contentType },
		}),
	);
}
